import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

import { DataProvider } from '../../providers/data/data';

@Component({

   selector: 'page-popover-dx',
   templateUrl: 'popover-dx.html'
})

export class PopoverDxPage
{

   private initVal;
   private callback;


   /** ----- Constructor ----- **/

   constructor( private data: DataProvider,
                private viewCtrl: ViewController,
                private params: NavParams )
   {

      this.initVal = this.params.get( 'init' );
      this.callback = this.params.get( 'callback' );

   }


   /** ----- View LifeCycle ----- **/

   onBtnClicked( inIdx )
   {

      this.callback( inIdx ).then( () => {

         this.viewCtrl.dismiss();
      });

   }

}



// WEBPACK FOOTER //
// ./src/pages/popover-dx/popover-dx.ts